// extracted by mini-css-extract-plugin
export default {"error":"form-error-module__error___go4go","icon":"form-error-module__icon___79onY"};